module.exports = __webpack_public_path__ + "assets/img/37_1021_big.ed20368a.jpg";